module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921022334_T.745c6ff7.jpg";